import { render, staticRenderFns } from "./CustomGroupQuestions.vue?vue&type=template&id=15246a55&scoped=true"
import script from "./CustomGroupQuestions.vue?vue&type=script&lang=js"
export * from "./CustomGroupQuestions.vue?vue&type=script&lang=js"
import style0 from "./CustomGroupQuestions.vue?vue&type=style&index=0&id=15246a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15246a55",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExpedienteDetailsGroupQuestionsFileDialog: require('/opt/atlassian/pipelines/agent/build/components/expediente/details/GroupQuestionsFileDialog.vue').default})
